import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";

import { Competence } from "core/blueprint/competencelist/CompetenceListService";
import { textFieldCellStyle } from "style/table/TableStyles";
import CreateTextField from "utils/edit/CreateTextField";

export type NewCompetenceRowProps = {
	onCreate: (competence: Competence) => void;
};

const NewCompetenceRow: React.FC<NewCompetenceRowProps> = (
	props: NewCompetenceRowProps
) => {
	function onCreateCriterion(name: string): void {
		if (name === "") {
			return;
		}

		props.onCreate(new Competence(name));
	}

	return (
		<TableRow>
			<TableCell />
			<TableCell />
			<TableCell />
			<TableCell sx={textFieldCellStyle(true, true)}>
				<CreateTextField
					id="name-field"
					variant="standard"
					fullWidth
					onCreate={onCreateCriterion}
				/>
			</TableCell>
		</TableRow>
	);
};

export default NewCompetenceRow;
